// extracted by mini-css-extract-plugin
module.exports = {"labelText":"Dropdown_labelText__q7o8N"};